var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',_vm._g(_vm._b({staticClass:"custom-checkbox",attrs:{"value":true,"unchecked-value":false},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},'b-form-checkbox',_vm.$attrs,false),_vm.mountEventListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }